<template>
  <div class="form-check">
    <Field
      :id="id"
      :class="hidden ? 'form-check-input-hidden' : 'form-check-input'"
      type="checkbox"
      :label="label"
      :name="field"
      :value="selectedValue === 'false' ? 'false' : 'true'"
      :checked="isChecked"
      :selectedValue="selectedValue"
      :required="required"
      v-model="selectedValue"
      @change="selection"
      v-on="validationListeners"
      :nomsg="nomsg"
      :disabled="disabled"
      :hidden="hidden"
    />
    <slot name="label"></slot>
    <p :class="nomsg ? 'cc_terms ' : ''" :for="id" v-if="label != ''">
      {{ label }}
    </p>
    <pre v-if="!nomsg && !nopre" class="help"> {{ errorMessage }}</pre>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { Field, useField } from "vee-validate";

const emit = defineEmits(["selected"]);

const props = defineProps({
  class: String,
  label: String,
  value: String,
  trueValue: String,
  falseValue: String,
  id: String,
  required: Boolean,
  selectedValue: {
    type: String,
    default: "false",
  },
  field: {
    type: String,
    required: true,
  },
  validateRule: {
    type: String,
  },
  nomsg: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  nopre: {
    type: Boolean,
    default: false,
  },
  hidden: {
    type: Boolean,
    default: false,
  },
});

const hidden = ref(props.hidden);

const selectedValue = ref(props.selectedValue);

const isChecked = ref(props.value === props.selectedValue);

const { value, errorMessage, handleBlur } = useField(
  () => props.field,
  props.validateRule,
  {
    validateOnValueUpdate: false,
  }
);

const selection = () => {
  emit("selected", selectedValue.value);
};

const validationListeners = {
  blur: (evt: Event | undefined) => handleBlur(evt, true),
};

watch(
  () => props.selectedValue,
  (newValue) => {
    isChecked.value = props.value === newValue;
  }
);

watch(selectedValue, (newValue) => {
  value.value = newValue;
});
</script>

<style scoped>
label {
  display: block;
  line-height: 130%;
}

.help {
  color: red;
  margin-bottom: 0px;
  font: 400 16px/130% "Outfit", sans-serif;
}

.form-check-input {
  width: 20px;
  height: 20px;
  border-color: #cb03bc;
  border-radius: 25px;
  box-shadow: none;
  margin-top: 1px;
}

.form-check-input-hidden {
  width: 20px;
  height: 20px;
  border-color: white;
  border-radius: 25px;
  box-shadow: none;
  margin-top: 1px;
}

.form-check-input:checked::before {
  display: flex;
  width: 18px;
  height: 24.5px;
  font-size: 12px;
  content: url("@/svg/btn_select_selected.svg");
  position: absolute;
  align-items: center;
  justify-content: center;
  font-family: "sans-serif";
}

.cc_terms {
  margin-bottom: 0;
  color: var(--black-medium-54, rgba(0, 0, 0, 0.54));
  font-family: Outfit;
  font-size: 14px;
  font-weight: 500;
  line-height: 130%;
  margin-left: 8px;
  margin-bottom: 0px;
}

.form-check-input:focus {
  outline: none;
}
</style>
